module.exports = __webpack_public_path__ + "static/media/shoes.19f41e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoes.jpg
// module id = 1186
// module chunks = 33